import { useQuery } from '@tanstack/react-query';
import { magicQueryKeys } from './magicQueries.js';
import { useWoody } from '../../woody/woody.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';

const useQueryMagicSuggestions = (context, queryOptions) => {
  const { client } = useWoody();
  const query = useQuery({
    queryKey: magicQueryKeys.suggestions(context),
    queryFn: async (params) => {
      const safeSuggestionContext = params.queryKey[1];
      return client.v2("/v2/suggest-categories", {
        method: "post",
        body: safeSuggestionContext
      });
    },
    staleTime: 0,
    gcTime: 0,
    placeholderData: void 0,
    initialData: void 0,
    persister: void 0,
    ...queryOptions,
    enabled: isQueryEnabled([
      queryOptions?.enabled,
      !!context
    ])
  });
  return query;
};

export { useQueryMagicSuggestions };
//# sourceMappingURL=useQueryMagicSuggestions.js.map
